import React, { useState } from 'react';
import { Table, Text } from '@nextui-org/react';
import { AdminSessionDetail } from '../../../types/sessions';

interface Props {
    detail: AdminSessionDetail;
}

const EventsTab: React.FC<Props> = ({ detail }) => {
    const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

    const toggleRow = (eventId: string) => {
        const next = new Set(expandedRows);
        if (next.has(eventId)) next.delete(eventId);
        else next.add(eventId);
        setExpandedRows(next);
    };

    const columns = [
        { name: "OCCURRED AT", uid: "occurred_at" },
        { name: "EVENT TYPE", uid: "event_type" },
        { name: "EVENT DATA (SUMMARY)", uid: "event_data" }
    ];

    const renderCell = (event: any, columnKey: React.Key) => {
        switch (columnKey) {
            case "occurred_at":
                return <Text size={12}>{new Date(event.occurred_at).toLocaleTimeString()}</Text>;
            case "event_type":
                return <Text size={12} css={{ fontFamily: 'monospace' }}>{event.event_type}</Text>;
            case "event_data": {
                // simple summary
                let summary = '';
                if (event.event_data) {
                    const entries = Object.entries(event.event_data).slice(0, 3);
                    summary = entries.map(([k,v]) => `${k}=${v}`).join(' ');
                    if (Object.keys(event.event_data).length > 3) summary += ' ...';
                }
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text size={12} css={{ fontFamily: 'monospace', color: '#666' }}>{summary}</Text>
                        <button
                            onClick={() => toggleRow(event.event_id)}
                            style={{ background: 'none', border: 'none', color: '#0070f3', cursor: 'pointer', fontSize: '12px' }}
                        >
                            {expandedRows.has(event.event_id) ? 'Hide' : 'Expand'}
                        </button>
                    </div>
                );
            }
            default: return null;
        }
    };

    return (
        <div style={{ padding: '1rem' }}>
             <Table
                aria-label="Events table"
                compact
                shadow={false}
             >
                 <Table.Header columns={columns}>
                     {column => <Table.Column key={column.uid}>{column.name}</Table.Column>}
                 </Table.Header>
                 <Table.Body items={detail.events || []}>
                     {event => (
                         <Table.Row key={event.event_id}>
                             {(columnKey: React.Key) => (
                                 <Table.Cell>
                                     {renderCell(event, columnKey)}
                                     {columnKey === 'event_data' && expandedRows.has(event.event_id) && (
                                         <pre style={{ background: '#f5f5f5', padding: '0.5rem', marginTop: '0.5rem', fontSize: '11px', overflowX: 'auto', borderRadius: '4px' }}>
                                             {JSON.stringify(event.event_data, null, 2)}
                                         </pre>
                                     )}
                                 </Table.Cell>
                             )}
                         </Table.Row>
                     )}
                 </Table.Body>
             </Table>
        </div>
    );
};

export default EventsTab;